export default {
  title: 'Czy jesteś pewny/a?',
  description: 'Następujące grupy modyfikatorów (wraz z ich modyfikatorami) zostaną usunięte:',
  buttons: {
    yes: 'Tak',
    no: 'Nie',
  },
  toasts: {
    modifier_group_got_deleted: 'Grupy modyfikatorów zostały usunięte',
    failed_to_delete_modifier_group: 'Nie udało się usunąć grupy modyfikatorów',
  },
};
